export default __webpack_public_path__ + "static/media/imgNotAvailable.a1c1940d.jpg";